<template lang="pug">
div.usertype-button(:class="buttonClass" @click="onClick")
  .radio
    .inner-circle
  .utb-label
    .utb-label__content
      .icon
        template(v-if="isBusiness")
          img(src="./business.svg" width="30" height="27").individual
        template(v-if="isIndividual")
          img(src="./individual.svg" width="33" height="27").business
      slot Частное лицо

</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { UsertypeEnum } from '@/views/pages/auth/registration';

@Component({
  name: 'usertype-radio-button',
})
export default class UsertypeRadioButton extends Vue {
  @Prop({ default: false })
  checked!: boolean;

  @Prop({ default: UsertypeEnum.Individual })
  type!: UsertypeEnum;

  @Prop({ default: false })
  disabled!: boolean

  onClick() {
    if (this.disabled) return;
    this.$emit('input', !this.checked);
  }

  get isIndividual() {
    return this.type == UsertypeEnum.Individual;
  }

  get isBusiness() {
    return !this.isIndividual;
  }

  get buttonClass() {
    return {
      checked: this.checked,
      unchecked: !this.checked,
      disabled: this.disabled,
    };
  }
}
</script>

<style scoped lang="less">
@greenColor: #82BA2E;
@inactiveColor: #C7CDD1;

.usertype-button {
  &.disabled {
    cursor: not-allowed !important;
    opacity: 0.7;
    filter: grayscale(100);
  }

  &:not(.checked), &.unchecked {
    &:not(:hover) {
      .radio {
        .inner-circle {
          display: none;
        }
      }
    }

  }
  &:hover, &.checked {
    border: 1px solid @greenColor;
    .utb-label {
      color: @greenColor;
    }
    img {
      opacity: 1;
    }
    .radio {
      border: 1px solid @greenColor;
      //.inner-circle {
      //  background: @greenColor;
      //}
    }
  }
  &:hover {
    .radio {
      .inner-circle {
        background: @inactiveColor;
      }
    }
  }
  &.checked {
    .radio {
      .inner-circle {
        background: @greenColor;
      }
    }
    border: 1px solid @greenColor;
  }

  display: grid;
  grid-template-columns: max-content auto;
  grid-gap: 20px;
  align-items: center;
  .utb-label {
    margin: 0 auto;
    padding-right: 25px;
    .utb-label__content {
      display: grid;
      grid-template-columns: max-content auto;
      grid-gap: 5px;
      align-items: center;
      color: #666;
      margin: 0 auto;
    }

  }
  border-radius: 4px;
  border: 1px solid @inactiveColor;
  padding: 5px 20px;
  &:not(.disabled) {
    cursor: pointer;
    cursor: hand;
  }
  img {
    .desaturate();
    -webkit-filter: grayscale(1);
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: url(./business.svg#greyscale);
  }
}

.radio {
  display: block;
  border-radius: 100%;
  width: 22px;
  height: 22px;
  border: 1px solid @inactiveColor;
  position: relative;
  .inner-circle {
    position: absolute;
    border-radius: 100%;
    width: 12px;
    height: 12px;
    left: 4px;
    top: 4px;

    background: @inactiveColor;
    transform: matrix(1, 0, 0, -1, 0, 0);
  }

}

.desaturate() {
  -webkit-filter: grayscale(1);
  -webkit-filter: grayscale(100%);
  filter: gray;
  filter: grayscale(100%);
  filter: url(./business.svg#greyscale);
}
</style>
